import { ParameterType } from '@barthauer/abc/queries/parameters/core';

export const parameterTypeDatasource = [
  {
    value: ParameterType.String,
    displayText: 'Text',
  },
  {
    value: ParameterType.Number,
    displayText: 'Number',
  },
  {
    value: ParameterType.Date,
    displayText: 'Date',
  },
  {
    value: ParameterType.Boolean,
    displayText: 'Yes / no',
  },
  {
    value: ParameterType.DataAccessByObjectType,
    displayText: 'Object selection',
  },
  {
    value: ParameterType.DataAccessByValue,
    displayText: 'value selection',
  },
  {
    value: ParameterType.PicklistByColumn,
    displayText: 'Pick list (by column)',
  },
  {
    value: ParameterType.PicklistByName,
    displayText: 'Pick list (by name)',
  },
  {
    value: ParameterType.Query,
    displayText: 'Query',
  },
  {
    value: ParameterType.ContextSetting,
    displayText: 'File',
  },
  {
    value: ParameterType.ValueExpression,
    displayText: 'Value expression',
  },
];

export class Translation {
  title?: string;
  add?: string;
  edit?: string;
  delete?: string;
  newParameter?: string;
  deleteQuestion?: string;
  save?: string;
  cancel?: string;
  name?: string;
  nameRequired?: string;
  nameUnique?: string;
  nameNumeric?: string;
  label?: string;
  description?: string;
  type?: string;
  defaultValue?: string;
  requiredInput?: string;
  alwaysDefaultValue?: string;
  editMask?: string;
  minValue?: string;
  maxValue?: string;
  invalidValue?: string;
  yes?: string;
  no?: string;
  multiSelection?: string;
  filterCondition?: string;
  cSharpExpression?: string;
  columnExpression?: string;
  column?: string;
  cSharpExpressionRequired?: string;
}
